import React, { useState } from 'react';
import bgImage from '../assets/CD002.jpeg';
import { cultureDialogueAPI } from '../services/api';

const RequestInvitation = () => {
  const [formData, setFormData] = useState({
    name: '',
    title: '',
    organization: '',
    email: '',
    phone: '',
    city: '',
    linkedin: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState({ type: '', title: '', message: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError(null);
    setSubmitting(true);
    
    const allowedCities = ['ahmedabad'];
    const selectedCity = (formData.city || '').trim().toLowerCase();
    
    if (!selectedCity || !allowedCities.includes(selectedCity)) {
      const validationMessage = 'Preferred City must be Ahmedabad.';
      setSubmitError(validationMessage);
      setModalMessage({
        type: 'error',
        title: 'Invalid City Selection',
        message: validationMessage
      });
      setShowModal(true);
      setSubmitting(false);
      return;
    }
    
    try {
      const submitData = {
        name: formData.name,
        title: formData.title,
        organization: formData.organization,
        email: formData.email,
        phone: formData.phone,
        linkedin: formData.linkedin || '',
        city: selectedCity
      };
      
      console.log('Submitting with data:', submitData);
      
      // Submit to API
      const result = await cultureDialogueAPI.submitRequest(submitData);
      
      // Show success modal
      setModalMessage({
        type: 'success',
        title: 'Thank you!',
        message: result.message || 'Thank you for your request. We will contact you shortly with details about the upcoming Culture Dialogue.'
      });
      setShowModal(true);
      
      // Reset form
      setFormData({
        name: '',
        title: '',
        organization: '',
        email: '',
        phone: '',
        city: '',
        linkedin: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      console.error('Error details:', error);
      console.error('Selected city was:', selectedCity);
      
      let errorMessage = error.message || 'Failed to submit request. Please try again.';
      
      // Check if this is a city validation error from backend
      const errorLower = errorMessage.toLowerCase();
      const isCityError = errorLower.includes('city') || 
                          errorLower.includes('mumbai') ||
                          errorLower.includes('bangalore') || 
                          errorLower.includes('pune') ||
                          errorLower.includes('delhi') ||
                          errorLower.includes('ahmedabad');
      
      // If backend rejects a valid city, it's a backend configuration issue
      if (isCityError && allowedCities.includes(selectedCity)) {
        errorMessage = 'There was an issue with the server validation. Please try again or contact support if the problem persists.';
      } else if (isCityError) {
        // Backend rejected an invalid city
        errorMessage = 'Preferred City must be Ahmedabad.';
      }
      
      setSubmitError(errorMessage);
      
      // Show error modal
      setModalMessage({
        type: 'error',
        title: 'Submission Failed',
        message: errorMessage
      });
      setShowModal(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section 
      id="request-invitation" 
      className="py-[60px] bg-cover bg-center bg-fixed opacity-0 animate-fadeIn-delayed-6"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${bgImage})`
      }}
    >
      <div className="w-[90%] max-w-[1200px] mx-auto px-5">
        <h2 className="font-heading font-semibold text-[2rem] relative pb-[15px] mb-8 text-white text-center">
          Request Invitation
        </h2>
        <p className="max-w-[700px] mx-auto mb-5 text-center text-base text-white">
          Given the intimate nature of this dialogue, we curate participation to ensure rich peer exchange
        </p>
        
        <form onSubmit={handleSubmit} className="max-w-[550px] mx-auto bg-[#F5F5F0] border-2 border-[rgba(0,0,0,0.1)] rounded-xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.1)]">
          <div className="mb-3">
            <label htmlFor="name" className="block mb-1 font-medium text-[0.85rem] text-[#333333]">
              Name *
            </label>
            <input 
              type="text" 
              id="name" 
              name="name" 
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full p-2 bg-white border border-[rgba(0,0,0,0.1)] rounded text-[#333333] font-body text-[0.85rem] focus:outline-none focus:border-[#6B4DC4] focus:bg-white"
            />
          </div>
          
          <div className="mb-3">
            <label htmlFor="title" className="block mb-1 font-medium text-[0.85rem] text-[#333333]">
              Title *
            </label>
            <input 
              type="text" 
              id="title" 
              name="title" 
              value={formData.title}
              onChange={handleChange}
              required
              className="w-full p-2 bg-white border border-[rgba(0,0,0,0.1)] rounded text-[#333333] font-body text-[0.85rem] focus:outline-none focus:border-[#6B4DC4] focus:bg-white"
            />
          </div>
          
          <div className="mb-3">
            <label htmlFor="organization" className="block mb-1 font-medium text-[0.85rem] text-[#333333]">
              Organization *
            </label>
            <input 
              type="text" 
              id="organization" 
              name="organization" 
              value={formData.organization}
              onChange={handleChange}
              required
              className="w-full p-2 bg-white border border-[rgba(0,0,0,0.1)] rounded text-[#333333] font-body text-[0.85rem] focus:outline-none focus:border-[#6B4DC4] focus:bg-white"
            />
          </div>
          
          <div className="mb-3">
            <label htmlFor="email" className="block mb-1 font-medium text-[0.85rem] text-[#333333]">
              Email *
            </label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-2 bg-white border border-[rgba(0,0,0,0.1)] rounded text-[#333333] font-body text-[0.85rem] focus:outline-none focus:border-[#6B4DC4] focus:bg-white"
            />
          </div>
          
          <div className="mb-3">
            <label htmlFor="phone" className="block mb-1 font-medium text-[0.85rem] text-[#333333]">
              Phone *
            </label>
            <input 
              type="tel" 
              id="phone" 
              name="phone" 
              value={formData.phone}
              onChange={handleChange}
              required
              className="w-full p-2 bg-white border border-[rgba(0,0,0,0.1)] rounded text-[#333333] font-body text-[0.85rem] focus:outline-none focus:border-[#6B4DC4] focus:bg-white"
            />
          </div>
          
          <div className="mb-3">
            <label htmlFor="city" className="block mb-1 font-medium text-[0.85rem] text-[#333333]">
              Preferred City *
            </label>
            <select 
              id="city" 
              name="city" 
              value={formData.city}
              onChange={handleChange}
              required
              className="w-full p-2 bg-white border border-[rgba(0,0,0,0.1)] rounded text-[#333333] font-body text-[0.85rem] focus:outline-none focus:border-[#6B4DC4] focus:bg-white"
            >
              <option value="">Select a city</option>
              <option value="ahmedabad">Ahmedabad</option>
            </select>
          </div>
          
          <div className="mb-3">
            <label htmlFor="linkedin" className="block mb-1 font-medium text-[0.85rem] text-[#333333]">
              LinkedIn Profile (optional)
            </label>
            <input 
              type="url" 
              id="linkedin" 
              name="linkedin" 
              value={formData.linkedin}
              onChange={handleChange}
              className="w-full p-2 bg-white border border-[rgba(0,0,0,0.1)] rounded text-[#333333] font-body text-[0.85rem] focus:outline-none focus:border-[#6B4DC4] focus:bg-white"
            />
          </div>
          
          <button 
            type="submit" 
            disabled={submitting}
            className="w-full mt-2 bg-gradient-to-br from-[#6B4DC4] to-[#4ECDC4] text-white font-heading font-semibold py-[10px] px-7 rounded-[25px] uppercase tracking-[1px] text-[0.9rem] transition-all duration-300 shadow-[0_4px_15px_rgba(107,77,196,0.4)] hover:bg-gradient-to-br hover:from-[#4ECDC4] hover:to-[#6B4DC4] hover:-translate-y-[3px] hover:shadow-[0_6px_25px_rgba(78,205,196,0.5)] border-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:transform-none"
          >
            {submitting ? 'Submitting...' : 'Submit Request'}
          </button>
          
          {submitError && (
            <p className="mt-3 text-red-600 text-sm text-center">
              {submitError}
            </p>
          )}
        </form>
      </div>

      {/* Success/Error Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fadeIn">
          {/* Backdrop */}
          <div 
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setShowModal(false)}
          ></div>
          
          {/* Modal Content */}
          <div className="relative bg-cream rounded-xl shadow-2xl max-w-md w-full p-6 animate-scaleIn border-2 border-purple border-opacity-20">
            {/* Close Button */}
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-purple transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Icon */}
            <div className="flex justify-center mb-4">
              {modalMessage.type === 'success' ? (
                <div className="w-16 h-16 bg-gradient-to-br from-purple to-teal rounded-full flex items-center justify-center">
                  <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              ) : (
                <div className="w-16 h-16 bg-gradient-to-br from-purple to-teal rounded-full flex items-center justify-center">
                  <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
              )}
            </div>

            {/* Title */}
            <h3 className="text-2xl font-heading font-bold text-center mb-3 text-purple">
              {modalMessage.title}
            </h3>

            {/* Message */}
            <p className="text-gray-700 text-center mb-6 font-body">
              {modalMessage.message}
            </p>

            {/* Close Button */}
            <button
              onClick={() => setShowModal(false)}
              className="w-full py-3 px-6 rounded-[25px] font-heading font-semibold text-white transition-all duration-300 bg-gradient-to-br from-purple to-teal hover:from-teal hover:to-purple shadow-[0_4px_15px_rgba(107,77,196,0.4)] hover:shadow-[0_6px_25px_rgba(78,205,196,0.5)]"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default RequestInvitation;

